<template>
  <div class="buttons has-addons">
    <span class="button is-small" v-bind:class="{'is-selected': favorite, 'is-success': favorite}" :disabled="favorite" @click="handleFavorite(true)">{{$t("input.yes")}}</span>
    <span class="button is-small" v-bind:class="{'is-selected': !favorite, 'is-danger': !favorite}" :disabled="!favorite" @click="handleFavorite(false)">{{$t("input.no")}}</span>
  </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'SettingsFavInput',
  props: {
      line: Object,
      isCustom: Boolean,
  },
  beforeCreate: function() {
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    
    this.$bindAsArray('myProjectLines', firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/JobTaskLines'));
  },
  data: function() {
    return {

    }
  },
  computed: {
    favorite: function() {
        return _.get(_.find(this.myProjectLines, { 'no': this.line.no , 'task_no': this.line.task_no}), 'favorite');
    }
  },
  methods: {
    handleFavorite: function(isFavorite) {
        if(this.isCustom) {
          this.$firebaseRefs.myProjectLines.child(this.line['.key']).update({'favorite': isFavorite, 'no': this.line.project, 'task_no': this.line['.key']});
        } else {
          this.$firebaseRefs.myProjectLines.child(this.line['.key']).update({'favorite': isFavorite, 'no': this.line.no, 'task_no': this.line.task_no});
        }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
